<template>
  <div>
    <div v-if="!isMobile" class="row-fluid">
      <h4 class="gfn span5 text-uppercase">{{ guest.full_name }}</h4>
      <div class="span5">
        <div class="pull-right row-fluid">
          <div class="tutor" v-if="guest.tutor_full_name">
            <warning-msg :other-class="'span6'" :label="i18nJS.tutore" :message="guest.tutor_full_name" />
          </div>
          <div class="ammsost" v-if="guest.amm_sost_full_name">
            <warning-msg :other-class="'span6'" :label="i18nJS.amm_sost" :message="guest.amm_sost_full_name" />
          </div>
        </div>
      </div>
      <div class="pull-right">
        <a v-if="readBarCode" href="javascript:void(0)" @click="openBarCodeModal()">
          <fa-icon :icon-name="'fa-scanner-gun'" class="pulsante_comando js-tooltip" title="Scannerizza codice" />
        </a>
        <a v-if="guest.id" data-remote="true" :href="`/it/guest_period_data_sets/${guest.id}/guest_measurements/new.js`">
          <fa-icon :icon-name="'fa-thermometer'" class="pulsante_comando js-tooltip" title="Nuova Misurazione" />
        </a>
        <a v-if="canPrint" href="javascript:void(0)" data-toggle="modal" :data-target="`#ds_report_${guest.id}`">
          <fa-icon :icon-name="'fa-print'" class="pulsante_comando js-tooltip" title="Stampa" />
        </a>
      </div>
    </div>
    <div class="row-fluid" v-if="i18nJS[`allergies_warning`]">
      <guest-drugs-allergies-warning
        :key="guest.id"
        :header="i18nJS[`allergies_warning`]"
        :url="allergiesUrl"
        :guest-period-data-set-id="guest.id"
      />
    </div>
    <div class="row-fluid somm somm-heading">
      <div class="span1 center">
        <div class="row-fluid">
          <div :class="[confirmedTherapyEnabled ? 'span2' : 'span4']"></div>
          <div class="span2" v-if="confirmedTherapyEnabled">{{ i18nJS.confirmed_therapy }}</div>
        </div>
      </div>
      <div class="span3">{{ i18nJS.drug }}</div>
      <div class="span1 center somm_label js-tooltip" :title="`${i18nJS.sub_on}`">
        {{ i18nJS.fatto }}
        <input type="checkbox" :checked="allDone" @click="toggleAll" ref="checkAll" v-if="enableMassiveSomministration" />
      </div>
      <div class="span2 center">{{ i18nJS.dose }}</div>
      <div class="span1" v-if="enableWasteManagement">{{ i18nJS.waste }}</div>
      <div class="span2">
        <div>{{ i18nJS.notes }}</div>
        <div v-if="optionsCause">{{ i18nJS.causal }}</div>
      </div>
      <div class="span1 center">{{ i18nJS.war }}</div>
      <div class="span2">
        <a v-if="canPrint && isMobile" href="javascript:void(0)" data-toggle="modal" :data-target="`#ds_report_${guest.id}`">
          <fa-icon :icon-name="'fa-print'" class="pulsante_comando js-tooltip" title="Stampa" />
        </a>
      </div>
    </div>
    <div v-for="(therapy, index) in therapies" :class="['row-fluid', 'card', 'somm', `barTherapies${index}`]" :key="index">
      <div class="span1 center">
        <div class="row-fluid">
          <div :class="[confirmedTherapyEnabled ? 'span2' : 'span4']">
            <fa-icon
              v-if="therapy.guest_drug.documents"
              :icon-name="'fa-paperclip'"
              class="js-paperclip-document"
              :data-paperclip="therapy.guest_drug.documents"
            />
            <div class="title" v-if="therapy.versions_count > 0">
              <a
                class="js-tooltip btn btn-link"
                style="padding: 0px"
                :href="`${epUrl}/versions/for/DrugsSomministration/${therapy.id}`"
                data-toggle="modal"
                data-target="#modal-versions"
                data-skip-loader="true"
              >
                <i class="fa-light fa-file-lines js-tooltip" :title="`${i18nJS.model_changes} (${therapy.versions_count})`" />
              </a>
            </div>
            <br v-if="therapy.guest_drug.documents" />
            <a :href="sendToDiary(therapy)" data-remote="true">
              <fa-icon v-if="therapy.id" :icon-name="'fa-paper-plane'" />
            </a>
          </div>
          <div class="span2" v-if="confirmedTherapyEnabled">
            <fa-icon
              :icon-type="'fa'"
              :icon-name="therapy.guest_drug.confirmed ? 'fa-circle-check' : 'fa-circle-xmark'"
              :color="therapy.guest_drug.confirmed ? 'green' : 'red'"
              :no-theme="true"
            />
          </div>
        </div>
      </div>
      <div class="span3">
        <div class="row-fluid">
          <div class="span10">
            <div>
              <a
                v-if="therapy.drug_id"
                :href="bugiardinoLink.replace('__DRUG_ID__', therapy.drug_id)"
                data-target="#bugiardino"
                data-toggle="modal"
              >
                {{ therapy.guest_drug.drug_desc }}
              </a>
              <template v-else>
                {{ therapy.guest_drug.drug_desc }}
              </template>
              <div style="font-size: 85%" v-if="therapy.guest_drug.recurring">({{ therapy.guest_drug.recurring }})</div>
            </div>
            <div v-if="therapy.guest_drug.infusion">
              <div v-for="(description, index) in therapy.guest_drug.infusion_description" :key="index">- {{ description }}</div>
            </div>
            <div class="bugiardino_link" v-if="therapy.guest_drug.descr_principio_attivo">
              {{ therapy.guest_drug.descr_principio_attivo }}
            </div>
            <div class="bugiardino_link" v-if="therapy.guest_drug.categoria">{{ therapy.guest_drug.categoria }}</div>
            <div
              class="bugiardino_link"
              v-if="
                therapy.guest_drug.descr_via_somministrazione ||
                therapy.guest_drug.descr_forma_farmaceutica ||
                therapy.guest_drug.get_somm_type ||
                therapy.guest_drug.get_somm_form
              "
            >
              {{ [therapy.guest_drug.descr_via_somministrazione, therapy.guest_drug.descr_forma_farmaceutica].join(' ') }}
              {{ [therapy.guest_drug.get_somm_type, therapy.guest_drug.get_somm_form].join(' ') }}
            </div>
            <div class="royalblue bugiardino_link" v-if="therapy.guest_drug.prescrittore">
              {{ i18nJS.prescritto_da }}: {{ therapy.guest_drug.prescrittore }}
            </div>
            <a
              v-if="principioAttivo"
              data-toggle="modal"
              data-target="#modal-commercial-drugs"
              class="bugiardino_link"
              @click="emitCommercialDrugs(therapy)"
              href="#"
              >{{ i18nJS.commercial_name_associated }}</a
            >
            <div class="warning" v-if="therapy.guest_drug.notes_and_coumadin_notes">
              {{ i18nJS.notes }}: {{ therapy.guest_drug.notes_and_coumadin_notes }}
            </div>
            <div class="warning" v-if="therapy.guest_drug.allergy_atc && therapy.guest_drug.allergy_atc.response">
              {{ therapy.guest_drug.allergy_atc.message }}
            </div>

            <template v-if="therapy.guest_drug.ab && therapiesAbConstraintsEnabled">
              <template v-if="therapy.guest_drug.qta_max_gg_s">
                <div class="bugiardino_link">{{ i18nJS.qta_max_gg }}: {{ therapy.guest_drug.qta_max_gg_s }}</div>
              </template>
              <template v-if="therapy.guest_drug.time_range">
                <div class="bugiardino_link">{{ i18nJS.time_range }}: {{ therapy.guest_drug.time_range }}</div>
              </template>
              <template v-if="therapy.guest_drug.condizione_ab">
                <div class="bugiardino_link">{{ i18nJS.condizione_ab }}: {{ therapy.guest_drug.condizione_ab }}</div>
              </template>
            </template>
          </div>
          <drug-tag-label
            :therapy="therapy.guest_drug"
            :therapies-preparation-enabled="therapiesPreparationEnabled"
            :therapies-xp-enabled="therapiesXpEnabled"
          />
        </div>
      </div>
      <template v-if="hourLimit(therapy)">
        <template v-if="canEdit(therapy)">
          <div class="span1 center">
            <input
              type="checkbox"
              data-cy="toggle_therapy_checkbox"
              :checked="therapy.id"
              @click="() => toggleTherapy(index, therapy)"
              :class="`toggleCheck${index}`"
            />
            <br /><span v-if="therapy.id && readBarCode"
              ><fa-icon :icon-name="therapy.automatic_reading ? 'fa-barcode' : 'fa-hand'" :no-theme="true"
            /></span>
          </div>
          <div class="span2 center">
            <input
              type="text"
              v-model="therapy.qta_s"
              :class="['center', 'input-block-level', `toggleCheck${index}`]"
              min="0"
              :disabled="!therapy.id"
              @change="() => updateTherapy(index, therapy)"
            />
            <span v-if="therapy.qta != therapy.qta_prev" class="royalblue">({{ therapy.get_qta_prev }})</span>
          </div>
          <div class="span1" v-if="enableWasteManagement">
            <input
              v-if="therapy.id"
              type="text"
              v-model="therapy.waste_qta"
              min="0"
              @change="() => updateTherapy(index, therapy)"
              :class="[`toggleCheck${index}`, 'center', 'input-block-level']"
            />
            <span v-if="therapy.id" class="selectCauseId">
              <v-select2
                v-model="therapy.waste_motivation"
                :options-list="optionsWaste"
                @input="() => updateTherapy(index, therapy)"
                data-allow-clear="true"
                :class="`toggleCheck${index}`"
              />
            </span>
          </div>
          <div class="span2">
            <textarea
              v-if="therapy.id"
              v-model="therapy.notes"
              rows="1"
              @change="() => updateTherapy(index, therapy)"
              :class="[`toggleCheck${index}`, 'input-block-level']"
            />
            <div class="bugiardino_link royalblue">{{ therapy.guest_drug.before_after_meal }}</div>
            <span v-if="optionsCause && therapy.id">
              <v-select2
                v-model="therapy.cause_id"
                :options-list="optionsCause"
                @input="() => updateTherapy(index, therapy)"
                data-allow-clear="true"
                :class="`toggleCheck${index}`"
                v-if="optionsCause && therapy.id"
              />
            </span>
          </div>
          <div class="span1 center">
            <input
              type="checkbox"
              v-model="therapy.war"
              v-if="therapy.id"
              :class="`toggleCheck${index}`"
              @change="() => updateTherapy(index, therapy)"
            />
          </div>
        </template>
        <template v-else>
          <div class="span1 center">
            <fa-icon :icon-name="'fa-check'" :color="'green'" :no-theme="true" />
            <br /><span v-if="therapy.id && readBarCode"
              ><fa-icon :icon-name="therapy.automatic_reading ? 'fa-barcode' : 'fa-hand'" :no-theme="true"
            /></span>
          </div>
          <div class="span2 center">
            {{ therapy.qta_s }}
            <span v-if="therapy.qta != therapy.qta_prev" class="royalblue">({{ therapy.get_qta_prev }})</span>
          </div>
          <div class="span1 center" v-if="enableWasteManagement">{{ therapy.waste_qta }}</div>
          <div class="span2">
            {{ therapy.notes }}
            <div class="bugiardino_link royalblue">
              {{ therapy.guest_drug.before_after_meal }}
            </div>
            <template v-if="optionsCause">{{ therapy.get_cause_id }}</template>
          </div>
          <div :class="['span1', 'center', { 'fa-light fa-check-green': therapy.war }]"></div>
        </template>
        <div v-if="therapy.id && therapy.user" :class="[enableWasteManagement ? 'span1' : 'span2', 'somm_guet_activity']">
          <user-media
            :fullname="therapy.user.full_name"
            :job="therapy.user.job"
            :img="!isMobile && therapy.user.avatar"
            :datetime="therapy.start"
          />
        </div>
      </template>
      <div v-else class="span2 center">
        {{ therapy.qta_s }}
        <span v-if="therapy.qta != therapy.qta_prev" class="royalblue">({{ therapy.get_qta_prev }})</span>
      </div>
      <div v-if="magazzinoAndScarico" class="row-fluid">
        <div v-if="!canDischargeWarehouse" class="span12 center">
          <fa-icon :icon-name="'fa-triangle-exclamation'" :color="'yellow'" />
          Questa somministrazione non verrà scaricata dal magazzino a causa di permessi insufficienti. Contattare un coordinatore.
        </div>
        <div
          v-if="principioAttivo && (!therapy.guest_drug.val_conv || therapy.qta_tot === 0 || !therapy.guest_drug.somm_form)"
          class="span12 center"
        >
          <fa-icon :icon-name="'fa-triangle-exclamation'" :color="'yellow'" />
          Questa somministrazione non verrà scaricata dal magazzino, aggiornare la terapia con i valori di conversione.
        </div>
      </div>
    </div>
    <commercial-drugs-modal></commercial-drugs-modal>
    <v-modal :id="`ds_report_${guest.id}`">
      <span slot="header">
        {{ i18nJS.select_options }}
      </span>
      <ul>
        <li class="print_opt">
          <a
            :href="reportPath"
            data-remote="true"
            class="link-report btn btn-success js-watch-print-complete"
            data-skip-loader="true"
            data-disable-with="In stampa..."
          >
            Stampa somministrazioni mese corrente di {{ guest.full_name }}
          </a>
        </li>
        <li class="print_opt">
          <a href="javascript:void(0)" class="btn btn-success" data-toggle="modal" @click="setParamsOnModal">
            Stampa il piano terapie di {{ guest.full_name }}
          </a>
        </li>
      </ul>
    </v-modal>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import faIcon from '../faIcon';
import vSelect2 from '../vSelect2';
import warningMsg from '../warningMsg';
import userMedia from '../userMedia';
import drugTagLabel from '../tagLabels/drugTagLabel';
import vModal from '../vModal';
import commercialDrugsModal from '../guestDrugs/commercialDrugsModal';
import GuestDrugsAllergiesWarning from '@/epersonam/components/guestDrugs/guestDrugsAllergiesWarning.vue';
import { setupConfigMix } from '@/epersonam/mixins/setupConfig';

export default {
  name: 'guestTherapies',
  props: [
    'allergiesUrl',
    'guest',
    'therapies',
    'bugiardinoLink',
    'therapiesAbConstraintsEnabled',
    'enableWasteManagement',
    'enableMassiveSomministration',
    'optionsWaste',
    'optionsCause',
    'hoursLimit',
    'minutesBeforeLimit',
    'date',
    'time',
    'manageTherapy',
    'therapiesPreparationEnabled',
    'therapiesXpEnabled',
    'canPrint',
    'urlToDiary',
    'isMobile',
    'magazzinoAndScarico',
    'canDischargeWarehouse',
    'principioAttivo',
    'canSomministration',
    'confirmedTherapyEnabled',
    'timeId',
  ],
  mixins: [setupConfigMix],
  components: {
    GuestDrugsAllergiesWarning,
    userMedia,
    drugTagLabel,
    warningMsg,
    vSelect2,
    faIcon,
    vModal,
    commercialDrugsModal,
  },
  data() {
    return {
      epUrl: `${window.config.ePersonamService.ePersonamHost}/${window.locale}`,
    };
  },
  async beforeMount() {
    this.neededlabels = ['allergies_warning'];
    await this.setupLabels();
  },
  mounted() {
    $('#modal-versions').on('hidden.bs.modal', function (e) {
      $(this).removeData();
    });
    eventBus.$on('toggleTherapies', this.toggleByBarCode);
    eventBus.$on('openBarCodeModal', this.openBarCodeModal);
    $(document).on('ajax:success', '#modal_add_measurement', (evt, data, _status, _xhr) => {
      $('#modal_add_measurement').modal('hide');
    });
  },
  computed: {
    readBarCode() {
      return this.guest['therapies_enable_somministration_by_barcode?'];
    },
    doneTherapies() {
      if (!this.therapies) return [];

      return this.therapies.filter((t) => t.id);
    },
    ab() {
      return this.timeId == 'ab';
    },
    allDone() {
      if (!this.therapies) return false;

      return this.doneTherapies.length == this.therapies.length;
    },
    i18nJS() {
      return window.i18nJS;
    },
    reportPath() {
      let url = window.config.report_path;
      url = Utils.addGetParam(url, 'gbu_id', this.guest.guest_business_unit_id);
      url = Utils.addGetParam(url, 'guest_business_unit_id', this.guest.guest_business_unit_id);
      url = Utils.addGetParam(url, 'guest_period_data_set_id', this.guest.id);
      url = Utils.addGetParam(url, 'bu_id', this.guest.business_unit_id);
      url = Utils.addGetParam(
        url,
        'd',
        moment(this.date, i18nJS.time.formats.date_only).startOf('month').format(i18nJS.time.formats.date_only),
      );
      url = Utils.addGetParam(url, 'orientation', 'landscape');
      url = Utils.addGetParam(url, 'skip_page_creation', 'false');
      return Utils.addGetParam(url, 'worker', 'DrugsSomministrationsPdfWorker');
    },
  },
  methods: {
    openBarCodeModal() {
      eventBus.$emit('openModalBarCodeReader', this.guest.id, this.therapies);
    },
    isRightPreparation(somm, preparation) {
      return (
        (!somm.id || somm.qta < somm.qta_prev) &&
        ((somm.guest_drug_id === preparation.guest_drug_id &&
          somm.time_id == preparation.time_id &&
          moment(somm.dateprev, 'DD/MM/YYYY').format() === moment(preparation.date).format()) ||
          (!preparation.guest_drug_id &&
            (preparation.aic_erogato == somm.guest_drug.aic ||
              (preparation.deenova_equivalence_cod && preparation.deenova_equivalence_cod == somm.guest_drug.deenova_equivalence_cod))))
      );
    },
    async toggleByBarCode(preparations, code, deenovaCod) {
      if (deenovaCod) {
        await this.toggleByDeenova(preparations);
      } else {
        const index = this.therapies.findIndex((therapy) => therapy == preparations);
        preparations.other_aic = code;
        preparations.automatic_reading = true;
        await this.toggleTherapy(index, preparations);
        const message = {
          preparation: {
            description: preparations.guest_drug.description,
            guest_period_data_set: { full_name: this.guest.full_name },
            qta: preparations.qta_prev,
            serial: code,
          },
          read: true,
        };
        eventBus.$emit('stopToggleByBarCode', [message]);
      }
    },
    async toggleByDeenova(preparations) {
      if (!this.therapies || !preparations) return;
      let messages = [];
      let object_to_send = { guest_period_data_set: { full_name: this.guest.full_name }, serial: preparations.map((p) => p.serial).join() };

      for (const preparation of preparations) {
        const index = this.therapies.findIndex((somm) => this.isRightPreparation(somm, preparation));
        if (index >= 0) {
          let somministration = this.therapies[index];
          object_to_send = preparation.guest_period_data_set
            ? preparation
            : {
                description: somministration.guest_drug.description,
                guest_period_data_set: { full_name: this.guest.full_name },
                qta: preparation.qta_prev,
                serial: preparation.serial,
              };
          if (this.canEdit(somministration) && this.hourLimit(somministration)) {
            const qta_prev = somministration.qta_prev;
            const qta_tot_erogata = somministration.id ? somministration.qta + preparation.qta : preparation.qta;
            const qta_tot_somministrata = somministration.id ? somministration.qta : 0;
            const qta = Math.min(qta_tot_erogata, qta_prev);
            somministration['qta_s'] = `${qta}`;
            somministration['barcode'] = preparation.serial;
            somministration['single_dose_id'] = preparation.single_dose_id;
            somministration['automatic_reading'] = true;
            let other_message = null;
            if (qta_tot_erogata != qta_prev) {
              other_message =
                qta_tot_erogata > qta_prev
                  ? `Somministrare solo ${(qta_prev - qta_tot_somministrata).toString()} unità`
                  : `Mancano ancora ${(qta_prev - qta_tot_erogata).toString()} unità`;
            }
            if (preparation.aic != preparation.aic_erogato) {
              const note = [somministration['notes'], `${this.i18nJS.different_aic}: ${preparation.aic_erogato}`];
              somministration['notes'] = note.filter((n) => n && n != '').join('\n');
            }
            try {
              somministration.id ? await this.updateTherapy(index, somministration) : await this.toggleTherapy(index, somministration);
              messages.push({ preparation: object_to_send, read: true, message: other_message });
            } catch (exception) {
              let error_messages = '';
              exception.response.data.forEach((response) => (error_messages = `${error_messages}\n${response}`));
              messages.push({ preparation: object_to_send, read: false, message: error_messages });
            }
          } else {
            messages.push({ preparation: object_to_send, read: false, message: this.i18nJS.therapy_not_administer });
          }
        } else {
          messages.push({ preparation: preparation, read: false });
        }
      }
      eventBus.$emit('stopToggleByBarCode', messages);
    },
    emitCommercialDrugs(therapy) {
      eventBus.$emit('requestDrugsCommercialName', { drug_id: therapy.guest_drug.drug_id });
    },
    disabledInput(index) {
      $('.toggleCheck' + index).prop('disabled', true);
      $('.barTherapies' + index).addClass('processing');
    },
    enabledInput(index) {
      $('.toggleCheck' + index).prop('disabled', false);
      $('.barTherapies' + index).removeClass('processing');
    },
    toggleAll() {
      if (this.readBarCode && !confirm(this.i18nJS.confirm_somministration)) return;

      var therapiesToggled = [];
      if ($(this.$refs.checkAll).is(':checked')) {
        this.therapies.forEach((therapy, index) => {
          if (!therapy.id && this.canEdit(therapy) && this.hourLimit(therapy)) {
            therapiesToggled.push(therapy);
          }
        });
      } else {
        this.therapies.forEach((therapy, index) => {
          if (therapy.id && this.canEdit(therapy) && this.hourLimit(therapy)) {
            therapiesToggled.push(therapy);
          }
        });
      }
      eventBus.$emit('guestInSomministration', true);
      const promises = therapiesToggled.map((therapy) => this.sendRequestToggleTherapy(therapy));
      Promise.all(promises)
        .then((values) => {
          values.forEach(({ data }, index) => {
            this.setTherapyAfterManage(this.therapies[this.therapies.indexOf(therapiesToggled[index])], data);
          });
        })
        .catch(({ data }) => {
          //this.enabledInput(index)
          alert(data);
        })
        .finally(() => eventBus.$emit('guestInSomministration', false));
    },
    sendToDiary(therapy) {
      let url = this.urlToDiary.replace('__GPDS_ID__', this.guest.id);
      url = Utils.addGetParam(url, 'model', 'DrugsSomministrations');
      url = Utils.addGetParam(url, 'send_diary_model_name', 'DrugsSomministration');
      url = Utils.addGetParam(url, 'send_diary_model_id', therapy.id);
      url = Utils.addGetParam(url, 'value', 0);
      return Utils.addGetParam(url, 'url', this.manageTherapy + '/' + therapy.id);
    },
    async sendRequestToggleTherapy(therapy) {
      this.disabledInput(this.therapies.indexOf(therapy));
      if (therapy.id) {
        // destroy somministration
        return await apiConnector().delete(this.manageTherapy + '/' + therapy.id);
      } else {
        // create somministration
        therapy.date = moment().format(i18nJS.time.formats.date_only);
        therapy.time = moment().format('H:MM');
        const params = { drugs_somministration: therapy };

        return await apiConnector().post(this.manageTherapy, params);
      }
    },
    async toggleTherapy(index, therapy) {
      if (
        !therapy.id &&
        this.readBarCode &&
        !therapy.barcode &&
        therapy.guest_drug.preparation_done &&
        !confirm(this.i18nJS.confirm_somministration)
      )
        return;

      eventBus.$emit('guestInSomministration', true);
      try {
        const toggle = await this.sendRequestToggleTherapy(therapy);
        this.setTherapyAfterManage(therapy, toggle.data);
      } catch (exception) {
        this.manageError(exception, index);
      } finally {
        eventBus.$emit('guestInSomministration', false);
      }
    },
    async updateTherapy(index, therapy) {
      this.disabledInput(index);
      const params = { drugs_somministration: therapy };
      try {
        const manage = await apiConnector().put(this.manageTherapy + '/' + therapy.id, params);
        this.setTherapyAfterManage(therapy, manage.data);
      } catch (exception) {
        this.manageError(exception, index);
      }
    },
    manageError(exc, index) {
      this.enabledInput(index);
      let error_messages = '';
      if (exc.response.data.length) {
        exc.response.data.forEach((response) => (error_messages = `${error_messages}\n${response}`));
      } else {
        error_messages = 'Qualcosa non ha funzionato. il dato non verrà salvato. Riprovare più tardi';
      }
      alert(error_messages);
    },
    setTherapyAfterManage(old_therapy, therapy) {
      const index = this.therapies.indexOf(old_therapy);
      let doneWithVariations, done;

      this.$set(this.therapies, index, therapy);

      // done = number of somministration done and qta == qta_prev
      // doneWithVariations = number of somministration done and qta != qta_prev
      doneWithVariations = this.therapies.filter((t) => t.id && t.qta !== t.qta_prev).length;
      done = this.therapies.filter((t) => t.id && t.qta === t.qta_prev).length;
      eventBus.$emit('toggleAlertTherapy', this.guest.id, done, doneWithVariations);
      this.enabledInput(index);
    },
    hourLimit(therapy) {
      // constraint hour limit: non posso somministrare terapie future o che siano precedenti ad un orario prestabilito da un parametro
      const now = moment(),
        therapy_date_somministration = moment(this.date + ' ' + this.time, i18nJS.time.formats.aux),
        therapy_date_prev = moment(therapy.dateprev, i18nJS.time.formats.date_only);
      return (
        this.canSomministration &&
        (therapy.id ||
          (therapy_date_prev <= now &&
            (this.ab ||
              (therapy_date_somministration <= now &&
                moment.duration(now.diff(therapy_date_somministration)).asHours() < this.hoursLimit) ||
              (therapy_date_somministration > now &&
                moment.duration(therapy_date_somministration.diff(now)).asMinutes() < this.minutesBeforeLimit))))
      );
    },
    canEdit(therapy) {
      // constraint permission: posso modificare solo terapie fatte da me e che rispettino il limite di tempo massimo per la modifica
      const now = moment(),
        therapy_date_somministration = moment(therapy.start, i18nJS.time.formats.aux);
      return (
        !therapy.id ||
        window.userIsSuperUser == 'true' ||
        (therapy.user_id == window.userId &&
          (this.ab ||
            (therapy_date_somministration <= now && moment.duration(now.diff(therapy_date_somministration)).asHours() < this.hoursLimit) ||
            (therapy_date_somministration > now &&
              moment.duration(therapy_date_somministration.diff(now)).asMinutes() < this.minutesBeforeLimit)))
      );
    },
    setParamsOnModal() {
      $('[id*=ds_report]').modal('hide');
      $('#guest_business_unit_id_form_modal_therapy').val(this.guest.guest_business_unit_id);
      $('#guest_period_data_set_id_form_modal_therapy').val(this.guest.id);
      $('#modal_terapie_ospite').modal('show');
    },
  },
};
</script>
<style lang="scss" scoped>
div.somm_label {
  overflow: hidden;
  text-overflow: ellipsis;
}
.processing {
  background-color: lightgray;
}
.selectCauseId {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 5px;
  width: 100%;
}
</style>
